<template>
    
    <div class="container">
        <div class="row col-md-9 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">VIP Club</h2>
            <div class="row mt-5">
                <h5 class="mt-3">
                    Join our VIP club and enjoy a unique experience!
                    <br>
                    <br>
                    <br>
                    NABACO VIP CLUB is an exceptional opportunity for distinguished clients who seek premium services, exclusive access, and a superior experience.
                    VIP Club members enjoy exclusive features and benefits that are specially designed for this group.
                    If you're looking to take advantage of our finest services and offerings, our VIP Club is the perfect choice for you.
                    <br>
                    <br>
                    <br>
                    <br>
                    By joining our VIP Club, you’ll enter an exclusive world of premium services and privileges. Apply for membership now and experience the difference.
                    <br>
                    <br>
                    <button class="btn-gold my-2">
                      <a href="../sign-up" style="color: black; text-decoration: none;">Signin</a>
                    </button>
                </h5>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style scoped>
*{
    direction: ltr;
}
</style>